import $ from 'jquery';

$(document).ready(function() {
	if ($('.js-info-text-limited span').height() > $('.js-info-text-limited').height()) {
		$('.js-info-text-limited').next('.js-info-text-more').addClass('show');
	}
	$(document).on('click', '.js-info-text-more', function() {
		$(this).prev('.js-info-text-limited').addClass('show');
		$(this).removeClass('show');
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/one-event/event-info-text.js